import { Container, Grid } from '@mui/material';
// import './bidask.css'

import BaseBidAskComponent from '../dejavubidask/baseComponent';


const BidAskComponentUSA = () => {

    return (
        <Grid>
            <Container maxWidth="xl" sx={{ flex: 1, display: 'flex', flexDirection: 'column', marginTop: 10, }}>
                <Grid container display="flex" alignItems="center" marginBottom={10}>
                    <Grid sm={6} paddingX={2}>
                        {BaseBidAskComponent(1, 'usa')}
                    </Grid>
                    <Grid sm={6} paddingX={2}>
                        {BaseBidAskComponent(2, 'usa')}
                    </Grid>
                </Grid>
            </Container>
        </Grid >
    );
};

export default BidAskComponentUSA;
